document.addEventListener('DOMContentLoaded', function() {
  // 1. SELECT ELEMENTS
  const backBtn = document.getElementById('explorerBackBtn');
  const sidebarTitle = document.getElementById('sidebarTitle');
  const partsBody = document.getElementById('parts-body');
  const finalImg = document.getElementById('final-diag-image');
  const finalTitle = document.getElementById('final-diag-title');
  const viewport = document.getElementById('zoomViewport');

  let scale = 1;
  let isDown = false;
  let startX, startY, scrollLeft, scrollTop;

  // 2. CORE NAVIGATION (Consolidated Logic)
  function updateUI(step, id = null, pushState = true) {
    // Toggle View Panes
    document.querySelectorAll('.view-pane').forEach(p => p.style.display = 'none');
    const targetPane = document.getElementById(`view-${step}`);
    if (targetPane) targetPane.style.display = 'block';

    // Filter Sidebar & Grid Items
    const items = document.querySelectorAll('.sidebar-item, .explorer-trigger');
    items.forEach(item => {
      const type = item.dataset.type || (item.classList.contains('brand-nav-item') ? 'brand' : item.classList.contains('model-nav-item') ? 'model' : 'diag');
      
      if (step === 'brands') {
        item.style.display = (type === 'brand') ? 'block' : 'none';
      } else if (step === 'models') {
        item.style.display = (type === 'model' && item.dataset.parent === id) ? 'block' : 'none';
      } else if (step === 'diagrams') {
        item.style.display = (type === 'diag' && item.dataset.parent === id) ? 'block' : 'none';
      }
    });

    // UI Labels
    if (step === 'brands') {
      sidebarTitle.innerText = "Make";
      backBtn.style.display = 'none';
    } else {
      sidebarTitle.innerText = step === 'models' ? "Category" : "Diagram List";
      backBtn.style.display = 'inline-block';
    }

    // URL Management
    if (pushState) {
      const params = new URLSearchParams(window.location.search);
      if (step === 'models') { params.set('1', id); params.delete('2'); params.delete('3'); }
      if (step === 'diagrams') { params.set('2', id); params.delete('3'); }
      if (step === 'brands') { params.delete('1'); params.delete('2'); params.delete('3'); }
      history.pushState({step, id}, '', '?' + params.toString());
    }
  }

  // 3. CLICK EVENTS (Unified Handler)
  document.addEventListener('click', function(e) {
    const link = e.target.closest('.explorer-trigger, .sidebar-item, .sidebar-back-link');
    if (!link) return;

    if (link.id === 'explorerBackBtn') {
      const p = new URLSearchParams(window.location.search);
      if (p.has('3')) updateUI('diagrams', p.get('2'));
      else if (p.has('2')) updateUI('models', p.get('1'));
      else updateUI('brands');
      return;
    }

    e.preventDefault();
    const type = link.dataset.type || (link.classList.contains('brand-nav-item') ? 'brand' : link.classList.contains('model-nav-item') ? 'model' : 'diag');
    const id = link.dataset.id;

    if (type === 'diag') {
      finalTitle.innerText = link.dataset.title || link.innerText;
      finalImg.src = link.dataset.img;
      partsBody.innerHTML = '';
      const template = link.querySelector('.diagram-products-data');
      if (template) partsBody.appendChild(template.content.cloneNode(true));
      
      updateUI('parts', id);
      scale = 1; 
      finalImg.style.transform = `scale(1)`;
    } else {
      updateUI(type === 'brand' ? 'models' : 'diagrams', id);
    }
  });

  // 4. ZOOM & PAN (Optimized)
  const updateZoom = (s) => {
    scale = Math.min(Math.max(1, s), 4);
    finalImg.style.transform = `scale(${scale})`;
    if (scale === 1) viewport.scrollTo(0,0);
  };

  document.getElementById('zoomIn').onclick = () => updateZoom(scale + 0.5);
  document.getElementById('zoomOut').onclick = () => updateZoom(scale - 0.5);

  viewport.onmousedown = (e) => {
    if (scale <= 1) return;
    isDown = true;
    startX = e.pageX - viewport.offsetLeft;
    startY = e.pageY - viewport.offsetTop;
    scrollLeft = viewport.scrollLeft;
    scrollTop = viewport.scrollTop;
  };
  viewport.onmouseleave = viewport.onmouseup = () => isDown = false;
  viewport.onmousemove = (e) => {
    if (!isDown) return;
    viewport.scrollLeft = scrollLeft - (e.pageX - viewport.offsetLeft - startX) * 2;
    viewport.scrollTop = scrollTop - (e.pageY - viewport.offsetTop - startY) * 2;
  };

  // 5. INITIAL LOAD CHECK
  const p = new URLSearchParams(window.location.search);
  if (p.get('3')) {
    const target = document.querySelector(`.diag-nav-item[data-id="${p.get('3')}"]`);
    if (target) target.click();
  } else if (p.get('2')) updateUI('diagrams', p.get('2'), false);
  else if (p.get('1')) updateUI('models', p.get('1'), false);
});